import { useMemo } from 'react';

import { useApplicationContext } from '../../utils/withApplicationContext';
import { getIsRealtor } from '../../selectors/newbuilding/getIsRealtor';
import { useSelector } from 'react-redux';

/**
 * Баннер "Циан.Ипотека для профи" может быть показан?
 */
export const useIsMortgageBrokerBannerAvailable = (): boolean => {
  const { config } = useApplicationContext();
  const isRealtor = useSelector(getIsRealtor);

  const isBannerEnabled = !!config.get<boolean>('Transaction.MortgageBrokerMainBannerInObjectCard.Enabled');

  return useMemo(() => Boolean(isBannerEnabled && isRealtor), [isBannerEnabled, isRealtor]);
};
